export const Routes = {
    Default: {
        path: "/"
    },
    Login: {
        path: "/login"
    },
    DashBoard: {
        path: "/dashboard"
    },
    Prescription: {
        path: "/enterPrescriptions"
    },   
    OrderStatusView: {
        path: "/status"
    },   
    Lenconfirm: {
        path: "/confirmation"
    },   
    ForgotPassword: {
        path: "/forgot-password"
    },   
    CreatePassword: {
        path: "/create-password"
    },
    ResetPassword: {
        path: "/reset-password"
    },
       Orders: {
        path: "/orders"
    },
       OrderDetails: {
        path: "/orders/order-details/:id"
    },
    VaDistributorHome: {
        path: "/distributor"
    },
    VaDistributorSettings: {
        path: "/distributor/settings"
    },
    VaDistributorTransactions: {
        path: "/distributor/transactions"
    },
    VaDistributorHospitalVolume: {
        path: "/distributor/hospital-volume"
    },
    AudiologistHome: {
        path: "/audiologist"
    },
    AudiologistLogin: {
        path: "/audiologist/login"
    },
    AccessDenied: {
        path: "/access-denied"
    },
    CreateOrderUpload: {
        path: "/admin/orders/create/upload"
    },
    CreateOrderReview: {
        path: "/admin/orders/create/review"
    },
    CreateOrderManual: {
        path: "/admin/orders/create/manual"
    },
    VaDistributorsAdmin: {
        path: "/admin/va-distributors"
    },
    VaDistributorDetails: {
        path: "/admin/va-distributors/details"
    },
    RedemptionCodes: {
        path: "/redemption-codes"
    },
    AppVersions: {
        path: "/app-versions"
    },
}
